var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.LexonTooltipComponent,
    {
      attrs: { message: _setup.props.title, position: "top", isWidthAuto: "" },
    },
    [
      _c(
        "div",
        { attrs: { slot: "activator-element" }, slot: "activator-element" },
        [
          _c("span", { ref: "textElement", staticClass: "lf-header-title" }, [
            _vm._v(_vm._s(_setup.props.title)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }